import React from 'react'
import { createRoot } from 'react-dom/client'
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import App from './App'
import resources from './locales'

const SUPPORTED_LANGUAGES = ['fr', 'en', 'de', 'it', 'es']

if (process.env.REACT_APP_MOCKS_ENABLED) {
  //mocks()
}

// Workaround for "Cannot have two HTML5 backends at the same time." issue
if (window.__isReactDndBackendSetUp) {
  window.__isReactDndBackendSetUp = false
}

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  fallbackLng: 'en',
  supportedLngs: SUPPORTED_LANGUAGES,
  fallbackNS: ['translation'],
  ns: ['stime', 'translation'],
  defaultNS: 'stime',
  interpolation: { escapeValue: false },
})
const detectedLanguage = navigator.language?.split('-')[0];
if (detectedLanguage && SUPPORTED_LANGUAGES.includes(detectedLanguage)) {
  i18n.changeLanguage(detectedLanguage);
}

const container = document.getElementById('root')
const root = createRoot(container)
root.render(<App logo="/images/wifirstcenter.svg" i18n={i18n} />)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
